import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

const ProjectCard = ({ project, index = 0 }) => {
  const statusColors = {
    Ideation: 'bg-blue-100 text-blue-800',
    Building: 'bg-yellow-100 text-yellow-800',
    Testing: 'bg-purple-100 text-purple-800',
    Live: 'bg-green-100 text-green-800'
  };

  return (
    <motion.div 
      className="bg-white rounded-2xl shadow-lg overflow-hidden cursor-pointer group border-4 border-indigo-100 hover:border-indigo-400 transition-all"
      data-testid="project-card"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1, duration: 0.5 }}
      whileHover={{ y: -8, scale: 1.02 }}
    >
      <div className="p-6 relative">
        {/* Gradient overlay on hover */}
        <motion.div
          className="absolute inset-0 bg-gradient-to-br from-indigo-500/5 to-purple-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          initial={false}
        />
        
        <div className="relative z-10">
          <div className="flex justify-between items-start mb-3">
            <motion.h3 
              className="text-xl font-bold text-gray-900 group-hover:text-indigo-600 transition-colors"
              data-testid="project-card-name"
              whileHover={{ x: 2 }}
            >
              {project.name}
            </motion.h3>
            <motion.span 
              className={`px-3 py-1 rounded-full text-xs font-semibold ${statusColors[project.status]}`} 
              data-testid="project-card-status"
              whileHover={{ scale: 1.1 }}
            >
              {project.status}
            </motion.span>
          </div>
          <p className="text-gray-600 text-sm mb-3 font-medium" data-testid="project-card-tagline">{project.tagline}</p>
          <p className="text-gray-700 mb-4 line-clamp-2" data-testid="project-card-description">{project.description}</p>
          <div className="flex items-center justify-between">
            <motion.span 
              className="text-xs font-semibold text-indigo-600 bg-indigo-50 px-3 py-1 rounded-full"
              data-testid="project-card-category"
              whileHover={{ scale: 1.05 }}
            >
              {project.category}
            </motion.span>
            <Link
              to={`/project/${project.id}`}
              className="flex items-center text-indigo-600 hover:text-indigo-800 font-semibold text-sm group/link"
              data-testid="project-card-view-details"
            >
              View Details 
              <motion.span
                className="ml-1 inline-block"
                whileHover={{ x: 4 }}
              >
                <ArrowRight size={16} />
              </motion.span>
            </Link>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ProjectCard;
